import * as React from 'react';

var _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgApplePay = function SvgApplePay(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M2.67 7.386c.375.032.75-.19.984-.47.23-.29.383-.677.344-1.072-.332.016-.742.221-.976.51-.215.249-.399.652-.352 1.032M7.13 12.48V6.314h2.286c1.18 0 2.004.823 2.004 2.025s-.84 2.033-2.035 2.033h-1.31v2.108zM3.994 7.46c-.33-.02-.632.1-.875.198-.157.062-.29.115-.39.115-.114 0-.252-.056-.407-.118-.203-.082-.436-.176-.68-.171a1.6 1.6 0 0 0-1.363.838c-.586 1.02-.152 2.531.414 3.362.277.411.61.862 1.047.846.193-.007.331-.067.474-.128.165-.071.337-.145.604-.145.259 0 .423.072.58.14.15.066.293.129.506.125.454-.008.739-.411 1.016-.822.3-.442.431-.873.451-.938l.002-.008-.01-.005c-.1-.046-.865-.4-.873-1.351-.007-.798.607-1.202.704-1.266l.011-.007c-.39-.586-1-.649-1.21-.665m9.154 5.066c.594 0 1.144-.304 1.394-.787h.02v.74h.875V9.41c0-.889-.703-1.462-1.785-1.462-1.004 0-1.747.58-1.774 1.38h.852c.07-.38.418-.63.894-.63.579 0 .903.274.903.776v.34l-1.18.071c-1.098.068-1.692.522-1.692 1.313 0 .8.614 1.329 1.493 1.329m.254-.732c-.504 0-.825-.245-.825-.62 0-.388.309-.613.899-.649l1.05-.067v.348c0 .577-.484.988-1.124.988m4.938.926c-.38 1.08-.813 1.435-1.735 1.435-.07 0-.305-.008-.36-.023v-.74c.06.008.204.016.278.016.418 0 .652-.178.797-.64l.086-.274-1.602-4.488h.989l1.113 3.642h.02l1.113-3.642H20zM8.077 7.12h1.09c.82 0 1.289.443 1.289 1.222 0 .78-.469 1.226-1.293 1.226H8.077z",
        clipRule: "evenodd"
    })));
};

export { SvgApplePay as ReactComponent };
//# sourceMappingURL=ApplePay.svg.es.js.map
